"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeEnvs = void 0;
exports.nodeEnvs = [
    'development',
    'stage',
    'prod',
    'client-uat',
    'client',
];
//# sourceMappingURL=NodeEnv.js.map